module.exports = __webpack_public_path__ + "static/media/premium.712e9f55.png";